import { render, staticRenderFns } from "./xunchajihua1.vue?vue&type=template&id=140bcf33&scoped=true&"
import script from "./xunchajihua1.vue?vue&type=script&lang=js&"
export * from "./xunchajihua1.vue?vue&type=script&lang=js&"
import style0 from "./xunchajihua1.vue?vue&type=style&index=0&id=140bcf33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140bcf33",
  null
  
)

export default component.exports